import React, { useState } from 'react';
import { Share2, Link as LinkIcon, MoreHorizontal, Check } from 'lucide-react';
import { toast } from 'sonner';
import { WhatsAppIcon } from './WhatsAppIcon';

const sans = { fontFamily: 'Montserrat, sans-serif' };
const rowBtn = 'flex items-center gap-2 px-3 py-2 text-[11px] tracking-wider uppercase text-white/70 hover:text-white hover:bg-white/10 transition-colors w-full text-left';

const ShareRow = ({ label, url, text, copiedKey, copied, onCopied }) => {
  const canNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    onCopied(copiedKey);
    toast.success('Link copied');
  };

  const nativeShare = async () => {
    try { await navigator.share({ title: text, text, url }); } catch (e) { /* user dismissed */ }
  };

  return (
    <div className="py-1" data-testid={`share-row-${copiedKey}`}>
      <p className="px-3 pt-1 pb-1 text-[9px] tracking-[0.2em] uppercase text-[#c9a87c]" style={sans}>{label}</p>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={rowBtn}
        style={sans}
        data-testid={`share-whatsapp-${copiedKey}`}
      >
        <WhatsAppIcon className="w-4 h-4" /> WhatsApp
      </a>
      <button onClick={copy} className={rowBtn} style={sans} data-testid={`share-copy-${copiedKey}`}>
        {copied === copiedKey ? <Check className="w-4 h-4 text-[#c9a87c]" /> : <LinkIcon className="w-4 h-4" />}
        {copied === copiedKey ? 'Copied' : 'Copy link'}
      </button>
      {canNativeShare && (
        <button onClick={nativeShare} className={rowBtn} style={sans} data-testid={`share-more-${copiedKey}`}>
          <MoreHorizontal className="w-4 h-4" /> More (Instagram…)
        </button>
      )}
    </div>
  );
};

export const ShareMenu = ({ photo, categoryName }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(null);
  const origin = window.location.origin;
  const photoUrl = `${origin}/photo/${photo.id}`;
  const collectionUrl = `${origin}/gallery?category=${photo.category}`;

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center justify-center w-11 h-11 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors"
        aria-label="Share"
        aria-expanded={open}
        data-testid="lightbox-share-btn"
      >
        <Share2 className="w-5 h-5" />
      </button>

      {open && (
        <div
          className="absolute right-0 top-12 w-60 py-1 border border-white/10 shadow-2xl fade-in-up"
          style={{ background: '#1f1f1f', animationDuration: '0.2s' }}
          data-testid="share-menu"
        >
          <ShareRow label="This photo" copiedKey="photo" url={photoUrl}
            text={`"${photo.title}" by Elina K. Photography`} copied={copied} onCopied={setCopied} />
          <div className="border-t border-white/10" />
          <ShareRow label={`${categoryName} collection`} copiedKey="collection" url={collectionUrl}
            text={`${categoryName} photography by Elina K.`} copied={copied} onCopied={setCopied} />
        </div>
      )}
    </div>
  );
};
